// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"664":"files","934":"folders"}[chunkId] || chunkId) + "." + {"551":"0766256d","600":"bd0ad3ae","664":"274a889c","740":"5db2b8c7","840":"fd09765c","934":"4f39830a","969":"d92c6835"}[chunkId] + ".js";
};